import PropertyType from "@/model/PropertyType";

const PROPERTY_TYPES: PropertyType[] = [
  "APARTMENT",
  "HOUSE",
  "STUDIO",
  "LOFT",
  "VILLA",
  "CHALET",
  "CABIN",
  "ROOM",
];

export default PROPERTY_TYPES;
